import { Send } from "lucide-react";
import { SectionCard } from "../SectionShell";
import { inputCls, ToggleRow } from "./Fields";

export const FeedbackSettings = ({ content, setC, toggleContentFlag, sendTestFeedbackAlert, sendingTestAlert }) => (
  <SectionCard id="feedback" testId="section-feedback-settings" className="mb-4">
    <div className="grid sm:grid-cols-2 gap-4 mb-5">
      <ToggleRow testId="content-feedback-visible" label="Feedback section" sub="Shows the feedback form and sharings on the website" checked={!!content.feedback_visible} onChange={(v) => toggleContentFlag("feedback_visible", v)} />
      <ToggleRow testId="content-feedback-enabled" label="Accept new feedback" sub="Lets visitors submit text / audio / video" checked={!!content.feedback_enabled} onChange={(v) => toggleContentFlag("feedback_enabled", v)} />
    </div>
    <div className="grid sm:grid-cols-2 gap-5">
      <div>
        <label className="text-xs uppercase tracking-widest text-muted-foreground">Max audio length (seconds)</label>
        <input type="number" min="5" data-testid="content-audio-max" value={content.audio_max_sec ?? 120} onChange={(e) => setC("audio_max_sec", parseInt(e.target.value || "0", 10))} className={inputCls} />
      </div>
      <div>
        <label className="text-xs uppercase tracking-widest text-muted-foreground">Max video length (seconds)</label>
        <input type="number" min="5" data-testid="content-video-max" value={content.video_max_sec ?? 60} onChange={(e) => setC("video_max_sec", parseInt(e.target.value || "0", 10))} className={inputCls} />
      </div>
    </div>
    <div className="mt-5">
      <label className="text-xs uppercase tracking-widest text-muted-foreground">Feedback approval alert email</label>
      <div className="mt-2 flex flex-col sm:flex-row gap-3">
        <input type="email" data-testid="content-feedback_alert_email" value={content.feedback_alert_email || ""} onChange={(e) => setC("feedback_alert_email", e.target.value)} placeholder="admin@example.com" className={`flex-1 ${inputCls} mt-0`} />
        <button type="button" data-testid="feedback-test-alert-btn" onClick={sendTestFeedbackAlert} disabled={sendingTestAlert || !(content.feedback_alert_email || "").trim()}
          className="inline-flex items-center justify-center gap-2 rounded-full border border-accent text-accent px-5 py-2.5 text-sm hover:bg-accent hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          <Send size={15} /> {sendingTestAlert ? "Sending…" : "Send test alert"}
        </button>
      </div>
      <p className="text-xs text-muted-foreground mt-2">Receives an alert whenever audio or video feedback is waiting for approval. Leave blank to pause alerts. Save after changing the email.</p>
    </div>
  </SectionCard>
);

export const TestimonialsSettings = ({ content, toggleContentFlag }) => (
  <SectionCard id="testimonials" testId="section-testimonials-settings" className="mb-4">
    <ToggleRow testId="toggle-testimonials_visible" label="Testimonials" sub="Tab + testimonials section on the website" checked={!!content.testimonials_visible} onChange={(v) => toggleContentFlag("testimonials_visible", v)} />
  </SectionCard>
);
